import { EnumerationModel } from '@bayclubs/court-booking-employee-api';

export class CategoryModel {
    static readonly tennis = { code: 'tennis', name: 'Tennis' } as EnumerationModel;
    static readonly squash = { code: 'squash', name: 'Squash' } as EnumerationModel;
    static readonly pickleball = { code: 'pickleball', name: 'Pickleball' } as EnumerationModel;
    static readonly racquetball = { code: 'racquetball', name: 'Racquetball' } as EnumerationModel;
}

export class CourtEventStatus {
    static readonly temporary = { code: 'temporary', name: 'Temporary' } as EnumerationModel;
    static readonly cancelled = { code: 'cancelled', name: 'Cancelled' } as EnumerationModel;
    static readonly confirmed = { code: 'confirmed', name: 'Confirmed' } as EnumerationModel;
    static readonly checkedIn = { code: 'checkedin', name: 'CheckedIn' } as EnumerationModel;
    static readonly noShow = { code: 'noshow', name: 'NoShow' } as EnumerationModel;
}

export class BlockedSlotDefinitionType {
    static readonly clinic = { code: 'clinic', name: 'Clinic' } as EnumerationModel;
    static readonly league = { code: 'league', name: 'League' } as EnumerationModel;
    static readonly lesson = { code: 'lesson', name: 'Lesson' } as EnumerationModel;
    static readonly liveBall = { code: 'liveball', name: 'Live Ball' } as EnumerationModel;
    static readonly maintenance = { code: 'maintenance', name: 'Maintenance' } as EnumerationModel;
    static readonly openPlay = { code: 'openplay', name: 'Open play' } as EnumerationModel;
    static readonly pickleballEvent = { code: 'pickleballevent', name: 'Pickleball Event' } as EnumerationModel;
    static readonly pickleballTournament = { code: 'pickleballtournament', name: 'Pickleball Tournament' } as EnumerationModel;
    static readonly privateEvent = { code: 'privateevent', name: 'Private Event' } as EnumerationModel;
    static readonly tennisTournament = { code: 'tennistournament', name: 'Tennis Tournament' } as EnumerationModel;
    static readonly usta = { code: 'usta', name: 'USTA' } as EnumerationModel;
    static readonly other = { code: 'other', name: 'Other' } as EnumerationModel;
}

export class CourtBookingPlayerStatus {
  static readonly pending = { code:'pending', name: 'Pending'} as EnumerationModel;
  static readonly accepted = { code:'accepted', name: 'Accepted'} as EnumerationModel;
  static readonly rejected = { code:'rejected', name: 'Rejected'} as EnumerationModel;
  static readonly deleted = { code:'deleted', name: 'Deleted'} as EnumerationModel;
  static readonly checkedIn = { code:'checkedin', name: 'Checked In'} as EnumerationModel;
  static readonly noShow = { code:'noshow', name: 'No Show'} as EnumerationModel;
}

export class TennisCourtType {
    static readonly indoor = { code: 'indoor', name: 'Indoor' } as EnumerationModel;
    static readonly outdoor = { code: 'outdoor', name: 'Outdoor' } as EnumerationModel;
}
export class CourtEventTimelineTrigger {
    static readonly blockedSlotCreated = { code: 'blockedslotcreated', name: 'BlockedSlotCreated' } as EnumerationModel;
    static readonly blockedSlotEdited = { code: 'blockedSlotEdited', name: 'BlockedSlotEdited' } as EnumerationModel;
    static readonly blockedSlotStatusChanged = { code: 'blockedslotstatuschanged', name: 'BlockedSlotStatusChanged' } as EnumerationModel;

    static readonly groupClassCreated = { code: 'groupclasscreated', name: 'GroupClassCreated' } as EnumerationModel;
    static readonly groupClassStatusChanged = { code: 'groupclassstatuschanged', name: 'GroupClassStatusChanged' } as EnumerationModel;

    static readonly courtBookingCreated = { code: 'courtbookingcreated', name: 'CourtBookingCreated' } as EnumerationModel;
    static readonly courtBookingEdited = { code: 'courtBookingEdited', name: 'CourtBookingEdited' } as EnumerationModel;
    static readonly courtBookingStatusChanged = { code: 'courtbookingstatuschanged', name: 'CourtBookingStatusChanged' } as EnumerationModel;

    static readonly courtBookingPlayerCreated = { code: 'courtbookingplayercreated', name: 'CourtBookingPlayerCreated' } as EnumerationModel;
    static readonly courtBookingPlayerStatusChanged = { code: 'courtbookingplayerstatuschanged', name: 'CourtBookingPlayerStatusChanged' } as EnumerationModel;
}

export class CourtVisibilityOption {
    static readonly closed = { code: 'closed', name: 'Closed' } as EnumerationModel;
    static readonly openForMembersAndBcReservations = { code: 'openformembersandbcreservations', name: 'OpenForMembersAndBcReservations' } as EnumerationModel;
    static readonly openForBcReservations = { code: 'openforbcreservations', name: 'OpenForBcReservations' } as EnumerationModel;
}
